import React, { useState,useEffect } from "react";
import { Drawer, Button, Form, Input, Select, Spin,message } from "antd";
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const EmailFlowDrawer = ({ visible, onClose, nodeData,onSave }) => {
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [body, setBody] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [emailTemplates,setEmailTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  
  
  useEffect(() => {
      if (visible){
        fetchEmailTemplates();
      } 
    }, [visible]);

  const handleSave = () => {
    if(!body && !selectedTemplate){
        message.error("Please enter an email body or select an email template.");
        return;
      }
    if(to || cc){
        message.error("Please enter to/cc");
        return;
    }
    const emailData = { to, cc, bcc, body, selectedTemplate };
    onSave('1',emailData);;
    onClose();
  };

  const fetchEmailTemplates = async () =>{
    try {
        setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
        const response = await apiService.makeCall();
        setEmailTemplates(response);
      } catch (error) {
        console.error('Error fetching objects:', error);
        message.error('Failed to fetch objects.');
      } finally {
        setLoading(false);
      }
    
  }
  return (
    <Drawer
      title="Configure Email"
      placement="right"
      onClose={onClose}
      visible={visible}
      width={600}
      zIndex={1002}   // higher than sidebar
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      footerStyle={{ textAlign: "right" }}
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <Form layout="vertical">
          <Form.Item label="To" required>
            <Input placeholder="Enter recipient email" value={to} onChange={(e) => setTo(e.target.value)} />
          </Form.Item>

          <Form.Item label="CC" required>
            <Input placeholder="Enter CC emails" value={cc} onChange={(e) => setCc(e.target.value)} />
          </Form.Item>

          <Form.Item label="BCC">
            <Input placeholder="Enter BCC emails" value={bcc} onChange={(e) => setBcc(e.target.value)} />
          </Form.Item>

          <Form.Item label="Email Template">
            <Select
              placeholder="Select Email Template"
              style={{ width: "100%" }}
              onChange={(value) => setSelectedTemplate(value)}
              value={selectedTemplate}
            >
              {emailTemplates?.map((template) => (
                <Option key={template.id} value={template.id}>
                  {template.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Body">
            <Input.TextArea
              placeholder="Enter email body"
              rows={5}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EmailFlowDrawer;
